'use strict';
var React = require('react');

/**
 * 显示处理多行文字
 */
var MultilineText = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired
  },
  render: function () {
    return (
      <div className="common-multi-line-text">
        {this.props.text.split('\n').map(function (line) {
          if (line.trim()) {
            return <p>{line}</p>;
          }
          return <br/>;
        })}
      </div>
    );
  }
});

module.exports = MultilineText;


/** WEBPACK FOOTER **
 ** ./src/views/common/MultilineText.jsx
 **/